export enum DiscountPermission {
  anyUser = 'anyUser',
  manager = 'Manager',
}

export enum SalesTaxType {
  Percentage = 'percentage',
  Fixed = 'fixed',
  Slab = 'slab',
}

export enum SalesTaxRoundConfig {
  HalfEvent = 'halfEven',
  HalfUp = 'halfUp',
  RoundDown = 'roundDown',
  RoundUp = 'roundUp',
}

export enum PaymentOfModule {
  GIFT_CARD = 'gift-card',
  QR = 'qr',
  NUGGET = 'nugget',
  ONLINE = 'online-ordering',
}
